import React from "react";
import { Link } from "react-router-dom";
import { isNotNullOrEmpty } from "../lib/utilities";

const BookList = ({ items }) => {
  const getOverlay = (item) => {
    const today = new Date();
    const pubDate = new Date(item.pubDate);
    const pubDateAddMonths = new Date(item.pubDate).setMonth(
      pubDate.getMonth() + 3
    );

    if (pubDate > today) {
      const imgtype = isNotNullOrEmpty(item.amazonId)
        ? "preorder"
        : "comingsoon";
      return (
        <img
          alt={`${imgtype} ${item.title}`}
          className="book-ribbon"
          src={`/assets/misc/${imgtype}.png`}
        />
      );
    } else if (pubDate < today && today < pubDateAddMonths) {
      const imgtype = "available";
      return (
        <img
          alt={`${imgtype} ${item.title}`}
          className="book-ribbon"
          src={`/assets/misc/${imgtype}.png`}
        />
      );
    }

    return undefined;
  };

  return (
    <div className="row">
      {items.map((item) => (
        <div className="col" key={item.id}>
          <Link to={`/book/${item.id}`}>
            <div className="book-frame">
              <img
                alt={item.title}
                className="book"
                src={`/assets/books/${item.id}.jpg`}
              />
              {getOverlay(item)}
            </div>
          </Link>
        </div>
      ))}
    </div>
  );
};

export default BookList;
